import Api from './baseApi';
import ApiConfig from './apiConfig'

export default {
  loginUrl: ApiConfig.baseURL + '/api-auth/connect/token',
  async fetchClaims() {
    try {
      const response = await Api.get('/ums/v1/authorization');
      return response.data;
    } catch(error) {
      return await Promise.reject(error);
    }
  },
  async fetchUserClaims(email) {
    return await Api.get('/ums/v1/authorization/' + email);
  },
  async fetchRoleClaims(name) {
    return await Api.get('/ums/v1/authorization/role/' + name);
  },
  async updateClaims(email, data) {
    try {
      const response = await Api.post('/ums/v1/authorization/sync/' + email, data);
      return response.data;
    } catch (error) {
      return await Promise.reject(error);
    }
  },
  async updateRoles(email, data) {
    return await Api.post('/ums/v1/authorization/assignRole/' + email, data);
  },
  async login(email, password) {
    const formData = new FormData();
    formData.set('username', email);
    formData.set('password', password);
    formData.set('grant_type', 'password');
    formData.set('client_id', 'js');
    formData.set('client_secret', '511536EF-F270-4058-80CA-1C89C192F69A');

    return await Api.post(this.loginUrl, formData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  },
  authUrl(form) {
    return Api.post('/ums/v1/url-authorization', form);
  },
  isAuth() {
    return Api.get('/ums/v1/authorization/is-auth');
  }
}
